<div class="background">
  <div class="activationContainer">
    <div class="activationContainerBox">
      <h1>Oh! Das hat leider nicht geklappt!</h1>
      <p>Bitte kontaktiere uns oder versuche es erneut.</p>
      <p>Zum <a routerLink="/legal">Kontakt</a></p>
    </div>
  </div>
</div>
